import { Box, Typography } from '@material-ui/core'
import QuestionAnswerIcon from '@material-ui/icons/QuestionAnswer'
import { GetStaticPaths, GetStaticProps } from 'next'
import React from 'react'

import HR from '@aletheia/common/components/HR'
import Link from '@aletheia/common/components/Link'
import Markdown from '@aletheia/common/components/Markdown'
import Page from '@aletheia/common/components/Page'
import Pill from '@aletheia/common/components/Pill'

import { fetchFaq, fetchFaqs, IFaq, isEntry, isTag } from '../../contentful'

type FAQSingleProps = {
  FAQ: IFaq
}

const FAQSingle: React.FC<FAQSingleProps> = ({ FAQ }) => {
  const { title, body, tags } = FAQ.fields
  return (
    <Page
      title={title}
      pageTitle={
        <>
          <QuestionAnswerIcon /> {title}
        </>
      }
      breadcrumbsBase={{ href: '/help', label: 'Help Center' }}
      variant="narrow"
    >
      {tags && (
        <>
          <Box>
            <Box component="span" marginRight={1}>
              <Typography component="span" variant="h6">
                Tagged as:
              </Typography>
            </Box>
            {tags
              .filter(isEntry)
              .filter(isTag)
              .map((tag) => (
                <Link
                  key={tag.sys.id}
                  href={`/help/tag/[slug]`}
                  as={`/help/tag/${tag.fields.slug}`}
                >
                  <Pill>{tag.fields.title}</Pill>
                </Link>
              ))}
          </Box>
          <HR />
        </>
      )}
      <Markdown>{body}</Markdown>
    </Page>
  )
}

export default FAQSingle

export const getStaticProps: GetStaticProps<
  FAQSingleProps,
  { id: string }
> = async ({ params }) => {
  if (!params?.id) throw new Error('ID parameter not provided')
  const FAQ = await fetchFaq(params.id)
  if (!FAQ) {
    return { notFound: true }
  }
  return {
    props: { FAQ },
    revalidate: 20,
  }
}

export const getStaticPaths: GetStaticPaths = async () => {
  const FAQs = await fetchFaqs()
  if (!FAQs) throw new Error('Missing FAQs')
  return {
    paths: FAQs.map((FAQ) => ({ params: { id: FAQ.sys.id } })),
    fallback: 'blocking',
  }
}
